var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('div',{staticClass:"map-container bg-dark-grey text-center"},[_c('h3',{staticClass:"txt-white"},[_vm._v("Où me trouver")]),_vm._v(" "),_c('div',{attrs:{"id":"map"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }